/**
 * Choosing a password from an emailed link.
 *
 * Signed out, like `applicationRepository`: the person has never been able to
 * sign in, and the uid and token from the link are the whole credential.
 */

import { api } from "@/api/client";

export interface PasswordSetup {
  uid: string;
  token: string;
  new_password: string;
}

export const passwordSetupRepository = {
  /** Answers with the account's email, so the next screen can say where to sign in. */
  setPassword: (input: PasswordSetup) =>
    api.post<{ email: string }>("/auth/password/set/", input),
};
